import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html } from 'lit';
import componentStyles from './tufts-infographic.css.lit';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { backgroundColor } from '../tufts-container/tufts-container';

/**
 * The Tufts Infographic Circle
 * @element tufts-infographic-circle
 *
 * @slot data
 * @slot description
 *
 * @attr bg-color same as container background-color
 */

@customElement('tufts-infographic-circle')
export class tuftsInfographicCircle extends OutlineElement {
  ngSlot = new SlotNGController(this);
  static styles: CSSResultGroup = [componentStyles];

  @property({
    type: String,
    reflect: true,
    attribute: 'bg-color',
  })
  bgColor: backgroundColor = 'white';

  render() {
    return html`<div class="circle ${this.bgColor}">
      ${this.ngSlot.conditionalNGSlot('data')}
      ${this.ngSlot.conditionalNGSlot('description')}
    </div>`;
  }
}
